// extracted by mini-css-extract-plugin
export default {"measure":"productForm_measure__BcESa","units":"productForm_units__9rtWM","unitType":"productForm_unitType__cdlGs"};